<script setup>
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
});
</script>

<template>
  <thead
    data-slot="table-header"
    :class="cn('[&_tr]:border-b sticky top-0 z-10', props.class)"
  >
    <slot />
  </thead>
</template>
